import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import * as React from "react";
import { connect } from "react-redux";
import { Container, Dropdown, Accordion, Card, Button, Form } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { VendorService } from "../../Common/Services/VendorService";
import { InvoiceService } from "../../Common/Services/InvoiceService";
import Customerorderslideout from '../Customerorderslideout';
import { Utils } from "../../Common/Utilis";
import _ from "lodash";
import paginationFactory from 'react-bootstrap-table2-paginator';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import createDOMPurify from "dompurify";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
//import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import 'react-tabs/style/react-tabs.css';
import chevronRight from "../../Common/Assets/Images/icons/bx-chevron-right.svg";
import InvoiceEntryslideout  from './InvoiceEntryslideout';
import  Vendororderslideout  from '../Vendororderslideout';
import  InvoiceSlideout  from '../Transaction/InvoiceSlideout';
import { FaBullseye } from 'react-icons/fa';
const { SearchBar } = Search;

const DOMPurify = createDOMPurify(window);
let storage = JSON.parse(localStorage.getItem("storage")!);
let currentUtcTime = storage === null ? "America/Chicago" : (storage.currentUtcTime as any);
const formattedDate  =   Utils.convertUtcToTimezoneFormat(new Date(),currentUtcTime);
 class InvoiceList extends React.Component<any, any> {
    private searchTimeout: ReturnType<typeof setTimeout> | null = null;
  isSearchCleared = false; 
  constructor(props: any) {
    super(props);
    this.bindfilter = this.bindfilter.bind(this);
    this.state = {
      searchQuery: "", 
      invoiceLoad:false,
      footershow: false,
      selectedRows: [],
      selectedRowscustomerid: [],
      activeKey: "first",
      invoiceTotal: 0,
      isstatus: true,
      isorderdate: true,
      iscustomername: true,
      iscustomercode: true,
      iscustomerpo: true,
      htmlItem: [],
      htmlErrorItem: [],
      htmlWarningItem: [],
      searcResult: [],
      customerOrderResult: [],
      customerOriginalOrderResult: [],
      invoiceList: [],
      invoiceId: 0,
      orderIds: [],
      itemsIds: [],
      selectedcolumn: "All",
      selectOptions: [
        {

          id: 'All', name: 'All'
        },
        {

          id: 'Vendor PO No.', name: 'Vendor PO No.'
        },
        { id: 'Vendor Name', name: 'Vendor Name' },
        { id: 'Order Date', name: 'Order Date' },
        { id: 'Part Description', name: 'Part Description' },
        { id: 'Order Type', name: 'Order Type' },
        { id: 'Status', name: 'Status' },
        { id: 'Invoice Date', name: 'Invoice Date' },
        { id: 'Invoice No', name: 'Invoice No' },

      ],
      formData:{
        InvoiceIds:[],
      }
    };


  }


  componentDidMount() {
    this.getVOItems();
    this.getInvoiceList();

     const params = new URLSearchParams(this.props.location.search);
    const invoiceId = params.get('id');

  if (invoiceId) {
    this.setState({
      showReceivableslideout: true,
      invoiceId,
      isSpinner: false,
    });
  }
  
  }

  componentDidUpdate(prevProps) {
        if (prevProps.locationId != this.props.locationId && !this.state.showReceivableslideout) {
                  this.getVOItems();
                  this.getInvoiceList();
         }
      }


  getVOItems() {
    let saveRequest: any = {};


    saveRequest.recordCount = 0;
    VendorService.GetAllVendorOrder(saveRequest)
      .then(async (result: any[] | null) => {

        if (result != null) {
          // console.log(result);
          this.setState({ customerOrderResult: result ,customerOriginalOrderResult: result}, () => {
            this.bindfilter();
          });
        }
        resolve();
      })
      .catch((err: any) => {
        toast.error(`Server Error, ${err}`);
        reject();
      });
  }


  handleSelect = (key: string | null) => {
    this.setState(prevState => ({
      activeKey: key,
      footershow: false,
      invoiceTotal: 0,
      selectedRows: [],
      itemsIds: [],
      customerOrderResult: this.state.customerOriginalOrderResult,
      selectedCount:0,
      invoiceList: this.state.originalinvoiceList
    }));
  };
  

  
  getInvoiceList = () => {
    let requestlist = { ...this.state.requestlist };
    requestlist.isApproved= 2;
    InvoiceService.GetVendorInvoiceList(requestlist)
  .then(async (result: any | null) => {
    
    if (result != null) {
      // console.log(result);
      this.setState({ invoiceList: [] }, () => {
        
        this.setState({  invoiceList: result, originalinvoiceList: result});
        this.bindfilter();


      });
    }
    resolve();
  })
  .catch((err: any) => {
    toast.error(`Server Error, ${err}`);
    reject();
  })
   .finally(() => {
        this.setState({ invoiceLoad: true });
      });
  };

  approveInvoice = (row: any) => {

      
    let invoices = this.state.invoiceList;
    invoices.forEach(element => {
       element.selected = (element.id == row.id);
    });
    this.approveInvoices();
};

  approveInvoices = () => {
    this.setState({ isSaveSpinner: true });
    let isFormValid = false;
    let InvoiceIds = this.state.invoiceList.filter(x => x.selected === true).map(r => r.id);
  
    
    let request: any = {};
    this.state.formData.InvoiceIds = InvoiceIds;  
  
    request = Object.assign({}, JSON.parse(JSON.stringify(this.state.formData)));
    isFormValid = true;
  
    if (isFormValid) {
      InvoiceService.ApproveVendorInvoice(request)
        .then(async (result: any | null) => {
          if (result !== null) {
             this.setState({ isSaveSpinner: false });
             toast.success('Approved information Saved.', {
              position: toast.POSITION.BOTTOM_RIGHT,
              containerId: "OrderSlideout",
            });
            this.getInvoiceList();
            this.setState({ footershow: false });

          }
  
          resolve();
        })
        .catch((error) => {
          this.setState({ isdefaultColDisabled: false, isSpinner: false });
          reject();
        });
    }
  };

  shownewslideout = () => {
    this.setState({ showSlideout: true, orderid: 0, isSpinner: false, });
  };

  showslideout = () => {
    this.setState({ showSlideout: true, isSpinner: false, });
  };
  
  closeVendorSlideOut = () => {
    this.setState({ showVendorSlideout: false, isSpinner: false, },()=>{
       this.getVOItems();
    this.getInvoiceList();
    });
  };

  showReceivableslideout = (row: any) => {
    if (this.state.customerOrderResult.filter((x) => x.selected === true).length === 0) {
      toast.error('Please select jobs to ship under this order');
      reject();
      return;
    }
    this.setState({
      showReceivableslideout: true, orderid: row.orderID,
      invoiceId: 0,
      orderIds: this.state.customerOrderResult.filter(x => x.selected === true).map(r => r.orderID),
      isSpinner: false,
    });

  };
  discard = () => {
    
    let customerOrderResult = this.state.customerOrderResult;
    customerOrderResult.forEach(element => {
     element.selected = false;      
    });

    this.setState({ customerOrderResult: customerOrderResult, footershow: false, invoiceTotal: 0, selectedRows: [], selectedRowscustomerid: [] });
   
  };
  
  showVendorSlideOut = (row) => {
      this.setState({
        showVendorSlideout: true, vendororderid: row.orderID, vendorordertype: row.vendorOrderType, isSpinner: false,
      });
  };


  showRcvslideout = () => {

    this.setState({
      showReceivableslideout: true ,
      invoiceId: 0,
     orderIds: this.state.customerOrderResult.filter(x => x.selected === true).map(r => r.orderID),
      isSpinner: false,
      footershow: false,
      selectedRows: [],
      selectedRowscustomerid:[],
    },  () => {
    

    }
  
  
  );
   
  };
  closeSlideOut = () => {
    this.setState({ showSlideout: false, isSpinner: false,invoiceTotal:0,selectedRows:[],selectedRowscustomerid:[],});
    //this.getCustomerItems();
  };

  closeInvoiceSlideOut = () => {    
    this.setState({ showReceivableslideout: false, isSpinner: false, invoiceTotal:0,selectedRows:[], itemsIds: [],customerOrderResult: this.state.customerOriginalOrderResult});
    this.getVOItems();
    this.getInvoiceList();
     this.handleSearch(this.state.searchQuery);
  };

  rowEvents = {
  onClick: (e: any, row: any, rowIndex: any) => {
    if (row.mainType === undefined) {

      if (
        row.entrytype?.toLowerCase() === "invoice" &&
        row.invoiceNo !== undefined &&
        row.invoiceNo.length > 0
      ) {
        this.setState({
          showInvoice: true,
          transactionId: row.id, 
          isSpinner: false,
        });
      }
      else if (
        row.invoiceNo !== undefined &&
        row.invoiceNo.length > 0
      ) {
        this.setState({
          showReceivableslideout: true,
          orderid: row.orderId,
          invoiceId: row.id,
          isSpinner: false,
        });
      }
      else {
        this.setState({
          showSlideout: true,
          orderid: row.orderID,
          invoiceId: 0,
          isSpinner: false,
        });
      }
    }
  },
};

   rowEvents1 = {


    onClick: (e: any, row: any, rowIndex: any) => {

        if (row.invoiceNo && row.status != 'Paid') {
          
          this.setState({
            showReceivableslideout: true,
             orderid: row.orderId,
             invoiceId: row.invoiceId,
            isSpinner: false,
          });

        }

        if(row.status == 'Paid'){
                 this.props.history.push({
                            pathname: '/Register'});
        }
      }
       
  };

  

  bindfilter = () => {
    let selectOptions = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.selectOptions))
    );

    this.setState({ selectOptions: selectOptions });

  };

  handleSelectedItem1 = (control: any, id: any) => {
    let searcResult1 = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.searcResult))
    );

    let chkisstatus = id == "Status" ? true : false;
    let chkisorderdate = id == "Order Date" ? true : false;
    let chkiscustomername = id == "Vendor Name" ? true : false;
    let chkiscustomercode = id == "Vendor Code" ? true : false;
    let chkiscustomerpo = id == "Vendor PO" ? true : false;


    if (id == "All") {
      chkisstatus = true;
      chkisorderdate = true;
      chkiscustomername = true;
      chkiscustomercode = true;
      chkiscustomerpo = true;

    }


    this.setState({
      searcResult: [], selectedcolumn: id, isstatus: chkisstatus, isorderdate: chkisorderdate,
      iscustomername: chkiscustomername, iscustomercode: chkiscustomercode, iscustomerpo: chkiscustomerpo
    },
      () => {
        this.setState({ searcResult: searcResult1 },()=>{
          this.handleSearch(this.state.searchQuery);
        });

      }


    );

  };


  handleOnSelect = (row,isSelect) => {
    console.log("Single row selection",row.totalAmount,row.rowId,row);

    let { invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid , itemsIds,searchQuery} = this.state;
    const flag = selectedRows[0] !== row.orderID;
    // let customerOrderResult = Object.assign(
    //   [], 
    //   JSON.parse(JSON.stringify(flag ? this.state.customerOriginalOrderResult : this.state.customerOrderResult ))
    // );

    
    let customerOrderResult:any = [];
       if (searchQuery && searchQuery.trim() !== '') {
            customerOrderResult = Object.assign(
      [], 
      JSON.parse(JSON.stringify(this.state.customerOrderResult ))
    );
    } else {
            customerOrderResult = Object.assign(
      [], 
      JSON.parse(JSON.stringify(flag ? this.state.customerOriginalOrderResult : this.state.customerOrderResult ))
    );
    }


    // if(selectedRows[0] !== row.orderID){
    //   toast.error("You can make an invoice of one PO at a time");
    //   return;
    // }

    const rowId = row.rowId;
    const customerID = row.customerID;

    let listItems = customerOrderResult.filter(
      (x) => x.rowId === rowId 
    );

    let checklistItem = this.state.selectedRowscustomerid.filter(
      (x) => x !== customerID
    );

    // console.log("isSelect, row", isSelect, row);
    // console.log("checklistItem", checklistItem);
    // console.log("invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid", invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid);
    // console.log("customerOrderResult", customerOrderResult);

    if (checklistItem.length === 0) {
      if (isSelect) {
        invoiceTotal = flag ? (row.unitPrice*row.qtyOrdered): invoiceTotal+(row.unitPrice*row.qtyOrdered);
      } else {
        invoiceTotal = flag ? (row.unitPrice*row.qtyOrdered): invoiceTotal-(row.unitPrice*row.qtyOrdered);
      }

      if (isSelect) {
        selectedRows = flag ? [...this.state.selectedRows,row.orderID]: [...this.state.selectedRows,row.orderID];
        itemsIds = flag ? [row.itemNo]:[...this.state.itemsIds, row.itemNo];
        selectedRowscustomerid = flag ? [row.customerID]: [...this.state.selectedRowscustomerid, row.customerID];
      } else {
        selectedRows = this.state.selectedRows.filter(x => x !== row.orderID);
        itemsIds = this.state.itemsIds.filter(x => x !== row.itemNo);
        selectedRowscustomerid = this.state.selectedRowscustomerid.filter(x => x !== row.customerID);
      }
    } else {
      toast.error("If you make one invoice for multiple orders, the customer should be the same.");
    }

    if (checklistItem.length == 0) {
      if (listItems.length > 0) {
        listItems.forEach((element: any, index: any) => {
          if (checklistItem.length == 0) {
            element.selected = isSelect;
          }
        });
      }
  }

      console.log(" selectedRows, selectedcustomerid, selectedRowscustomerid", selectedRows, selectedcustomerid, selectedRowscustomerid);


    this.setState({
      customerOrderResult: customerOrderResult,
      footershow: itemsIds.length > 0 ? true : false,
      invoiceTotal: invoiceTotal,
      selectedRows: selectedRows,
      itemsIds:itemsIds,
      selectedRowscustomerid: selectedRowscustomerid
    });
};



  handleOnSelectApproval = (row, isSelect) => {
    let { invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid } = this.state;

    let invoiceList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.invoiceList))
    );

    let listItem = invoiceList.filter(
      (x) => x.id === row.id
    );

      if (isSelect) {
        invoiceTotal += row.totalAmount;
        //selectedcustomerid = row.customerID;
      }
      else {
        invoiceTotal -= row.totalAmount;
        //selectedcustomerid = 0;
      }


      if (isSelect) {
        selectedRows = [...this.state.selectedRows, row.id];
       // selectedRowscustomerid = [...this.state.selectedRowscustomerid, rows[0].customerID];


      } else {
        selectedRows = this.state.selectedRows.filter(x => x !== row.id);
        //selectedRowscustomerid = this.state.selectedRowscustomerid.filter(x => x !== rows[0].customerID);
      }
    
  
      listItem[0].selected = isSelect;
      let selectedCount = invoiceList.filter(x=>x.selected == true).length;

      
  
    this.setState({ invoiceList: invoiceList, footershow: selectedCount > 0 ? true :false, invoiceTotal: invoiceTotal, selectedRows: selectedRows });


  };

  
  handleOnSelectAllApproval = (isSelect, rows) => {

    const ids = rows.map(r => r.id);
    let { invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid } = this.state;
    let invoiceList = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.invoiceList))
    );

    let listItems = invoiceList.filter(
      (x) => ids.includes(x.id)
    );




      if (isSelect) {
        invoiceTotal += rows[0].totalAmount;
        selectedcustomerid = rows[0].customerID;
      }
      else {
        invoiceTotal -= rows[0].totalAmount;
        selectedcustomerid = 0;
      }


      if (isSelect) {
        selectedRows = [...this.state.selectedRows, rows[0].id];
      } else {
        selectedRows = this.state.selectedRows.filter(x => x !== rows[0].id);
      }
    
    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {
          element.selected = isSelect;
      });
    };

    this.setState({ invoiceList: invoiceList, footershow: isSelect ? true :false, invoiceTotal: invoiceTotal, selectedRows: selectedRows, selectedRowscustomerid: selectedRowscustomerid });
  };

  handleOnSelectAll = (isSelect, rows) => {
 console.log("rowww",rows);

    let checklistItem = this.state.selectedRowscustomerid.filter(
      (x) => x !== rows[0].customerID
    );

    const ids = rows.map(r => r.rowId);
    let { invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid } = this.state;
        console.log("invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid", invoiceTotal, selectedRows, selectedcustomerid, selectedRowscustomerid);

    // if(selectedRows[0] !== rows[0].customerID){
    //   toast.error("You can make an invoice of one PO at a time");
    //   return;
    // }
    
    let customerOrderResult = Object.assign(
      [],
      JSON.parse(JSON.stringify(this.state.customerOriginalOrderResult))
    );

    let listItems = customerOrderResult.filter(
      (x) => ids.includes(x.rowId)
    );

    if (checklistItem.length == 0) {
      if (isSelect) {
        invoiceTotal = rows[0].totalAmount;
        selectedcustomerid = rows[0].customerID;
      }
      else {
        invoiceTotal = rows[0].totalAmount;
        selectedcustomerid = 0;
      }


      if (isSelect) {
        selectedRows = [ rows[0].orderID];
        selectedRowscustomerid = [ rows[0].customerID];


      } else {
        // selectedRows = this.state.selectedRows.filter(x => x !== rows[0].orderID);
        selectedRows = [];

        selectedRowscustomerid = this.state.selectedRowscustomerid.filter(x => x !== rows[0].customerID);
      }
    }
    else
    {

      toast.error("if you make one invoice for multiples order then customer should be same ");
      
    }
    
    if (checklistItem.length == 0) {
    if (listItems.length > 0) {
      listItems.forEach((element: any, index: any) => {

        if (checklistItem.length == 0) {
          element.selected = isSelect;
        }

      });
    };
  }
  console.log("customerOrderResult---",customerOrderResult);

    this.setState({ customerOrderResult: customerOrderResult, footershow: selectedRows.length>0 ? true :false, invoiceTotal: invoiceTotal, selectedRows: selectedRows, selectedRowscustomerid: selectedRowscustomerid });
  };


  handleSearch = (searchText) => {
      console.log("Search text:", searchText);
    
      this.setState({ searchQuery: searchText });
    
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
    
      const trimmedText = searchText.trim();
    
      if (trimmedText === "") {
        this.isSearchCleared = true; 
        console.log("Search cleared, resetting to original data");
        this.setState({ customerOrderResult: this.state.customerOriginalOrderResult });
        return;
      }
    
      if (trimmedText.length < 3) {
        this.isSearchCleared = true; 
        console.log("Search text too short, resetting to original data");
        this.setState({ searcResult: this.state.customerOriginalOrderResult });
        return;
      }
    
      this.isSearchCleared = false; 
    
      const columnselcted = this.state.selectedcolumn || "All";
    
      this.searchTimeout = setTimeout(() => {
        const request = {
          searchText: searchText,
          selectedColumns: columnselcted,
        };
    
        console.log("Calling API with request:", request);
    
        VendorService.GetVendorInvoiceSearch(request)
          .then((result) => {
            if (this.isSearchCleared) {
              this.setState({ customerOrderResult: this.state.customerOriginalOrderResult });
              return;
            }
    
            this.setState({ customerOrderResult: result });
          })
          .catch((err) => {
            if (this.isSearchCleared) return;
            toast.error(`Server Error: ${err}`);
          });
      }, 500);
    };
  
  
    onChangeHandler = (e) => {
      const searchText = e.target.value;
      this.setState({ searchQuery: searchText });
      this.handleSearch(searchText); // Calls the debounced function
    };

     showInvoiceslideout =  (row) => {
    this.setState({
       showInvoice: true,footershow:false, transactionId:0,isSpinner: false,invoiceTotal:0,selectedRows:[],selectedRowscustomerid:[],
    });
    };

  closeInvoiceslideout  = () => {
  this.setState({showInvoice:false,transactionId:0,inboxId:0,invoiceTotal:0,selectedRows:[],selectedRowscustomerid:[],emailString:""});
  this.getInvoiceList();
};

  render() {
    const { permissions } = this.props; 
    const hasApprovePermission = permissions && permissions['Vendor Invoices'] ? permissions['Vendor Invoices'].includes('Approve Invoice') : false;
    
    const customTotal = (from, to, size) => (
      <span className="text-muted">
        Showing {from} to {to} of {size} entries
      </span>
    );

      const getFilteredLength = () => {
      const { activeKey, customerOrderResult ,invoiceList} = this.state;

      if (activeKey === "first") {
        return customerOrderResult.filter((x) => x.mainType == 1).length;
      }

      if (activeKey === "second") {
         return invoiceList ? invoiceList.length : 0;
      }

      return 0;
    };

    const options = {

      showTotal: true,
      hideSizePerPage: false,
      hidePageListOnlyOnePage: true,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [{
        text: '10', value: 10
      },
      {
        text: '25', value: 25
      },
      {
        text: '50', value: 50
      },

      {
        text: 'All', value: getFilteredLength(),
      }] // A numeric array is also available. the purpose of above example is custom the text
    };


    const columns = [
      // {
      //   dataField: 'orderID',
      //   text: '#',
      //   headerStyle: { width: '10px' },
      // },
      {
        dataField: 'vendorPoNumber',
        text: 'Vendor PO No.',
        classes: 'text-start',
        sort: true,
        // headerStyle: { width: '100px',flex: 1 },
        searchable: this.state.iscustomerpo,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              <Button className="btn-link" onClick={() => this.showVendorSlideOut(row)}>
           {row.vendorPoNumber}
           </Button>
            </EllipsisWithTooltip>
          );
        },
      },
      {
        dataField: 'vendorCode',
        text: 'Vendor Code',
        classes: 'text-start',
        sort: true,
        hidden: true,
        // headerStyle: { width: '10px' ,flex: 1},
        searchable: this.state.iscustomercode,
      },
      {
        dataField: 'vendorName',
        text: 'Vendor Name',
        classes: 'text-start',
        // headerStyle: { width: '10px' ,flex: 1},
        sort: true,
        searchable: this.state.iscustomername,
        // headerStyle: { width: '300px' },
      },


      {
        dataField: 'orderDate',
        text: 'Order Date',
        sort: true,
        classes: 'text-start',
        // headerStyle: { width: '100px',flex: 1 },
        searchable: this.state.isorderdate,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {moment(row.orderDate).format("MM/DD/YYYY")}
            </EllipsisWithTooltip>
          );
        },
      },

      // ,
      {
        dataField: 'totalAmount',
        text: 'Order Amount',
        // headerClasses: 'amount',
        // headerStyle: { width: '100px',flex: 1 },
        classes: 'text-start pe-4 divgreen',
        sort: true,
        searchable: false,
        //headerStyle: { width: '300px' },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <EllipsisWithTooltip placement="bottom">
              {Utils.currencyFormat(row.totalAmount)}
            </EllipsisWithTooltip>
          );
        },
      },



      // {
      //   dataField: '',
      //   text: '',
      //   headerStyle: { width: '100px' },
      // },

      {
        dataField: 'status',
        text: 'Order Status',
        classes: 'text-start',
        sort: true,
        searchable: this.state.isstatus,
        formatter: (cell: any, row: any, rowIndex: any) => {
          return ( 
            <>

            <EllipsisWithTooltip placement="bottom" style={{paddingLeft:"6%"}} >
                
               <span className={row.status=="New" ?  "badge badge-pill badge-primary color-red" :  row.status=="Receiving" ? "badge badge-pill badge-primary color-blue" : "badge badge-pill badge-primary color-green"}> {row.status=="New" ?  "Open" : row.status } </span>
              </EllipsisWithTooltip>
              </>
          );
      },
        
        // headerStyle: { width: '700px',flex: 1 },
      },
      
      // {
      //   dataField: 'Inv',
      //   text: '',
      //   sort: true,
      //   searchable: false,
      //   //headerStyle: { width: '300px' },
      //   formatter: (cell: any, row: any, rowIndex: any) => {


      //     return (
      //       <EllipsisWithTooltip placement="bottom">
      //         {<Button className='btn btn-primary btn-sm py-0 btn-sml' onClick={(x) => this.showReceivableslideout(row)}>Save Invoice</Button>}
      //       </EllipsisWithTooltip>
      //     );
      //   },
      // },
      {
        dataField: '',
        text: 'Action',
        style: { display: this.state.footershow ? 'none' : '' },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="btn-group">
              <Dropdown
                onClick={(e) => { e.stopPropagation(); }}
                className="more-action"
                >
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary-white more"
                  id={"dropdown-more" + rowIndex}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey={"comments"} onClick={(x) => this.showReceivableslideout(row)}>Save Invoice </Dropdown.Item>
                  
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
      {
        dataField: '',
        text: '',
        style: { display: this.state.footershow ? '' : 'none' },
        formatter: (cell: any, row: any, rowIndex: any) => {
          return (
            <div className="btn-group">
              <Dropdown
                onClick={(e) => { e.stopPropagation(); }}
                className="more-action"
                >
                <Dropdown.Toggle
                  className="btn-outline-primary btn btn-primary-white more"
                  id={"dropdown-more" + rowIndex}
                  style={{ border: 'none', boxShadow: 'none' }}
                  disabled={true}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                    <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                    <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                  </svg>
                </Dropdown.Toggle>
               
              </Dropdown>
            </div>
          );
        },
      },

    ];


      const invoiceColumns = [
        {
          dataField: 'invoiceNo',
          text: 'Invoice No.',
          sort: true,
          // headerStyle: { width: '100px' },
          searchable: this.state.iscustomerpo,
        },
        {
          dataField: 'invoiceDate',
          text: 'Invoice Date',
          sort: true,

          // headerStyle: { width: '100px' },
          searchable: this.state.isorderdate,
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {moment(row.invoiceDate).format("MM/DD/YYYY")}
              </EllipsisWithTooltip>
            );
          },
        },
        {
          dataField: 'vendorName',
          text: 'Vendor Name',
          sort: true,
          searchable: this.state.iscustomername,
        },


        {
          dataField: 'dueDate',
          text: 'Due Date',
          sort: true,

          // headerStyle: { width: '100px' },
            searchable: this.state.isorderdate,
            formatter: (cell: any, row: any, rowIndex: any) => {
              return (
                <div style={{color: new Date(row.dueDate) < new Date(formattedDate)  ? 'red' : ''}}>
                <EllipsisWithTooltip placement="bottom">
                  {moment(row.dueDate).format("MM/DD/YYYY")}
                </EllipsisWithTooltip>
                </div>
              );
            },
        },

        
        {
          dataField: 'accountingPeriod',
          text: 'Accounting Period',
          sort: true,
          searchable: this.state.iscustomername,
          // headerStyle: { width: '300px' },
        },

        {
          dataField: 'totalAmount',
          text: 'Total Amount',
          // headerClasses: 'amount',
          classes: 'text-start pe-4 divgreen',
          sort: true,
          searchable: false,
          // headerStyle: { width: '100px' },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {Utils.currencyFormat(row.totalAmount)}
              </EllipsisWithTooltip>
            );
          },
        },

        {
                dataField: '',
                text: 'Status',
                sort: true,
                headerStyle: { width: '200px' },
                searchable: this.state.isvendorOrderType,
                formatter: (cell: any, row: any, rowIndex: any) => {
                  return ( 
                    <>
        
                    <EllipsisWithTooltip placement="bottom" style={{paddingLeft:"6%"}} > 
                      <span className={row.approved ?  "badge badge-pill badge-primary color-blue cursor-pointer" :  "badge badge-pill badge-primary color-red  cursor-pointer"}
                      onClick={() => {
                        if (row.approved) {
                          this.props.history.push({
                            pathname: '/InvoicePayment',
                            state: { paymentmethod: row.paymentMethod }
                          });
                        }
                      }}
          
                      > {row.approved ? 'Pending Payment':'Waiting Approval'}  
                        
                      </span>
                      </EllipsisWithTooltip>
                      </>
                  );
              },
            },
        {
            dataField: '',
            text: 'Action',
    
    
            formatter: (cell: any, row: any, rowIndex: any) => {
              return (
                <div className="btn-group">
                  <Dropdown
                    onClick={(e) => { e.stopPropagation(); }}
                    className="more-action"
                    >
                    <Dropdown.Toggle
                      className="btn-outline-primary btn btn-primary-white more"
                      id={"dropdown-more" + rowIndex}
    
                    >
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                        <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                        <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item eventKey={"comments"} 
                      onClick={() => {
                          if (row.approved) {
                            this.props.history.push({
                              pathname: '/InvoicePayment',
                              state: { paymentmethod: row.paymentMethod }
                            });
                          } else {
                            this.approveInvoice(row);
                          }
                        }}
                      >
                        {row.approved ? 'Pay' : 'Approve' } </Dropdown.Item>
                      
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              );
            },
          },
      

      ];

    

    const selectOptions = [{
      id: 0, column: 'Vendor PO'
    },
    { id: 1, column: 'Vendor Code' },
    { id: 2, column: 'Vendor Name' },
    { id: 3, column: 'Order Date' },
    { id: 4, column: 'Status' },

    ];

    const {

      showSlideout,
      showReceivableslideout,

    } = this.state;

     
    const expandSplitRow = {
      parentClassName: 'parent-expand-foo',
      bgColor: '#00BFFF',
      renderer: (row: any, rowIndex: any) =>  renderItemTableChild(row, rowIndex) ,
      showExpandColumn: true,
      // expandByColumnOnly: true,
      expandHeaderColumnRenderer: ({ isAnyExpands }) => {
        if (isAnyExpands) {
          return <div></div>;
        }
        return <div></div>;
      },
      expandColumnRenderer: ({ expanded }) => {
        
        if (expanded) {
          // this.setState({expanded:expanded},()=>{
          //   $('.selection-cell input').css('display', 'none');
          // });
          return (
            <span className="chevronExpended">
              <img src={chevronRight} alt="chevron Right" />
            </span>
          );
        }
        return (
          <span className="chevronCollpsed">
            <img src={chevronRight} alt="chevron Right" />
          </span>
        );
      },
    };
    const whiteBgFormatter = (column, colIndex) => {
      return <div className="white-bg"></div>;
    };

    const renderItemTableChild = (mainrow, rowIndex) => {

      let splitDetail: any = [];
      splitDetail = this.state.customerOrderResult.filter(
        (x) => x.orderID === mainrow.orderID && x.mainType === 2 && x.itemNo !== 0
      );

      const columnCOAChild = [
        {
          dataField: "orderID",
          text: "#",
          hidden: true,
        },    
        {
          dataField: "id",
          text: "#",
          hidden: true,
          classes:"expanding-bar",
        },
        
        {
          dataField: "srno",
          text: "Sr No.",
          hidden: false,
          editable: false,
  headerStyle: { width: '10%' },
           classes:"expanding-bar",
          headerAttrs: (column, colIndex) => ({ tabIndex: "-1" }),
          formatter: (cell: any, row: any, rowIndex: any) => {

            return (
              <div>
                {rowIndex + 1}
              </div>
            );
          },
        },
        
        {
          dataField: "partname",
          // text: "Part Name",
          // classes:"expanding-bar text-left",
          // headerStyle: { minWidth: '100px',width:'100px' },
          text: "Part Description",
  headerStyle: { width: '10%' },
          classes:"expanding-bar text-truncate",
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
             
              <div className="d-flex align-items-center txt-bold">
                 <div style={{width: '250px'}}>
                <EllipsisWithTooltip placement="bottom">
                  {row.partname}
                </EllipsisWithTooltip>
              </div>
              </div>
            );
        },
      },
        

        {
          dataField: "dueDate",
          text: "Due Date",          
          hidden:true,
        classes:"expanding-bar",
  headerStyle: { width: '10%' },
        },

        // {
        //   dataField: "jobDesc",
        //   text: "Description",
        //   hidden:true,
        //    classes:"expanding-bar",
        //    headerStyle: { minWidth: '100px',width:'100px' },
        // },

        {
          dataField: "unit",
          text: "Unit",
         classes:"expanding-bar",
  headerStyle: { width: '10%' },
        },
        {
          dataField: "qtyOrdered",
          text: "Qty Ordered",
          classes:"expanding-bar",
  headerStyle: { width: '10%' },

        },

        {
          dataField: "unitPrice",      
          text: "Unit Price",
          classes:"expanding-bar",
  headerStyle: { width: '10%' },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {Utils.currencyFormat(row.unitPrice)}
              </EllipsisWithTooltip>
            );
          },
        },

        {
          dataField: "discount",
          text: "Discount",
           classes:"expanding-bar",
  headerStyle: { width: '10%' },
        },
        {
          dataField: "totalAmount",
          text: "Total",
          classes:"expanding-bar text-center pe-4 divgreen",
          headerClasses: 'text-center pe-4',
  headerStyle: { width: '10%' },
          formatter: (cell: any, row: any, rowIndex: any) => {
            return (
              <EllipsisWithTooltip placement="bottom">
                {Utils.currencyFormat(row.unitPrice * row.qtyOrdered - row.discount)}
              </EllipsisWithTooltip>
            );
          },
        },


        {
          dataField: "jobNumber",
          text: "Job Order",
         classes:"expanding-bar",
  headerStyle: { width: '10%' },

        },
  {
          dataField: "invoiceNo",
          text: "Invoice No",
         classes:"expanding-bar",
  headerStyle: { width: '10%' },

        },
        {
  dataField: 'status',
  text: 'Status',
  headerStyle: { width: '10%' },
  headerClasses: 'text-end',
  classes: 'text-end',
  formatter: (cell: any, row: any) => {
    const status = row?.status;
    if (status === "Active") return null;

    const isPending = status === "Pending Payment";
    const badgeClass = isPending
      ? "badge badge-pill badge-primary color-blue"
      : "badge badge-pill badge-primary color-red";

    return (
      <EllipsisWithTooltip placement="bottom">
        <span
          className={badgeClass} >
          {status || ""}
        </span>
      </EllipsisWithTooltip>
    );
  },
        }

    

      ];
      
      return (
        <>
        <div className='px-4 p-4'>
       
          <BootstrapTable
        
            id="tblCOAchild"
            keyField="rowId"
            data={splitDetail}
            columns={columnCOAChild}
          //  rowClasses={ rowClasses }
            //rowEvents={this.rowEvents}
            selectRow={{
              mode: 'checkbox', clickToSelect: false,
               
              hideSelectAll: false,
              
              selected: splitDetail.filter((x) => x.selected === true).map(r => r.rowId),
              onSelect: this.handleOnSelect,
              onSelectAll: this.handleOnSelectAll,
              hideSelectColumn: false,
              selectColumnStyle: {
                backgroundColor: '#5c82ab08'
              },
                nonSelectable: splitDetail
              .filter(row => row.invoiceNo && row.invoiceNo.trim() !== '')
              .map(row => row.rowId)
              // hideSelectAll: false,
              
              // selected: splitDetail.filter((x) => x.selected === true).map(r => r.rowId),
              // onSelect: this.handleOnSelect,
              // onSelectAll: this.handleOnSelectAll,
              // hideSelectColumn: false,
               
            }}
            rowEvents={this.rowEvents1}
          />
         
        </div>
        </>
      );
    };


 
  




    return (
      <>
        <React.Fragment>


          
          <Container fluid className="body-sec">
          <div className="page-heading underline d-flex">

            Vendor Invoices
              {/* <div className="action-group d-flex flex-row ml-auto">
                <Button onClick={this.showInvoiceslideout}>Add Invoice</Button>
              </div> */}
            </div>

            <Tab.Container transition={false} defaultActiveKey="first" onSelect={this.handleSelect}>
              <section className="pb-3">
                <Nav className="nav nav-underline border-bottom">
                  <Nav.Item className="nav-item">
                    <Nav.Link eventKey="first">Inbox <span className="badge badge-light">{this.state.customerOrderResult.filter(
                    (x) => x.mainType == 1 && x.status != 'New'
                  ).length}</span>


                    </Nav.Link>
                    </Nav.Item>
                  
                    <Nav.Item className="nav-item">
                    {this.state.invoiceLoad && (
                    <Nav.Link eventKey="second">Approval <span className="badge badge-light"> {this.state.invoiceList.length}</span>

                    </Nav.Link>)}

                  </Nav.Item>
                  

                </Nav>
              </section>

              <Tab.Content>
                <Tab.Pane eventKey="first">

                  <ToolkitProvider
                    keyField="id"
                    data={this.state.customerOrderResult.filter((x) => x.mainType === 1 && x.status != 'New')}
                    columns={columns}

                     
                    search
                  >
                    {
                      props => (


                        <div >
                          <section className="d-flex flex-wrap gap-3 pb-2">
                            <div className="position-relative">
                               <Form.Control
                                                                              tabIndex={this.state.tabEnable}
                                                                              id="txtSearch"
                                                                              type="text"
                                                                            placeholder="Search"
                                                                              value={this.state.searchQuery}
                                                                              onChange={this.onChangeHandler}
                                                                              autoComplete="off"
                                                                              className="w-full"
                                                                            
                                                                              title=""
                                                                            />
                            </div>

                            <div
                            //className="input-group w-auto"
                            className="col-12 col-md-2"
                            >
                                <SingleDropdownListWithoutSearch

                                  itemList={this.state.selectOptions}
                                  handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                  defaultItem={this.state.selectedcolumn}
                                  defaultText={"Select Filter"}
                                  defaultName={this.state.selectedcolumn}
                                  controlID="1"
                                  id={"ddlselected"}

                                />
                            </div>

                          </section>
                          <section className="pb-3">
                            <div className="table-responsive divbottom"  >
                              <div className="ml-auto transactions-list expand-tbl">
                              <BootstrapTable id="tblCO"
                            {...props.baseProps}
                            keyField="rowId"
                            rowEvents={this.rowEvents}
                            expandRow={expandSplitRow}
                            pagination={paginationFactory(options)}
                            rowClasses={(row, rowIndex) =>
                                  row.mainType === 1 && row.status != 'New' ? "main-row" : "expand-row"
                                }
                          />
                                   {(this.state.footershow &&
                            <div className="TabFooter-Pay"
                            style={{ minWidth: "83.7%", width: "992px", maxWidth: "100%" }}
                            >
                              <div className="bulkSelectFooter">
                                <span className="shift-selected-count">{this.state.selectedRows.length}
                                  {" "}Selected</span>
                                <div className="FooterHorLine"></div>
                                <span className="shift-selected-count">Invoice Total: {Utils.currencyFormatWithOutdoller(this.state.invoiceTotal)}</span>
                                <div className="action-group d-flex flex-row mr-auto">
                                  <Button type="button"
                                  //className="btn-outline-primary btnHeight"
                                  //  onClick={(e) => { this.handleBtnEvent(e, "", 'bulk') }}
                                   onClick={(x) => this.showRcvslideout()}
                                  >Save Invoice</Button>

                                  <Button type="button"
                                   className='space btn btn-primary btn-discard'
                                   onClick={(x) => this.discard()}
                                  >Discard</Button>
                                </div>
                              </div>
                            </div>)}

                              </div>
                            </div>
                          </section>
                        </div>

                      )
                    }
                  </ToolkitProvider>


                </Tab.Pane>
                

              </Tab.Content>

              <Tab.Content>
                <Tab.Pane eventKey="second">

                  <ToolkitProvider
                    keyField="id"
                
data={this.state.invoiceList}
columns={invoiceColumns}
                     
                    search
                  >
                    {
                      props => (


                        <div >
                          <section className="d-flex flex-wrap gap-3 pb-2">
                            <div className="position-relative">
                              <SearchBar {...props.searchProps} />
                               {props.searchProps.searchText && props.searchProps.searchText.trim() !== "" && (
                              <button
                                type="button"
                                className="btn-clear-search"
                                onClick={() => props.searchProps.onSearch("")}
                                title="Clear search"
                              >
                                ×
                              </button>
                            )}
                            </div>

                            <div
                            //className="input-group w-auto"
                            className="col-12 col-md-2"
                            >
                                <SingleDropdownListWithoutSearch

                                  itemList={this.state.selectOptions}
                                  handleSelectedItem={this.handleSelectedItem1.bind(this, 1)}
                                  defaultItem={this.state.selectedcolumn}
                                  defaultText={"Select Filter"}
                                  defaultName={this.state.selectedcolumn}
                                  controlID="1"
                                  id={"ddlselected"}

                                />
                            </div>

                          </section>
                          <section className="pb-3">
                            <div className="table-responsive divbottom"  >
                              <div className="ml-auto transactions-list payroll-tbl">
                                <BootstrapTable
                                  {...props.baseProps}
                                    rowEvents={this.rowEvents}
                                    selectRow={{
                                      mode: 'checkbox', 
                                      clickToSelect: false, 
                                      hideSelectAll: true,
                                      selected: this.state.invoiceList.filter((x) => x.selected === true).map(r => r.id),
                                      onSelect: this.handleOnSelectApproval,
                                      onSelectAll: this.handleOnSelectAllApproval,
                                      nonSelectable: this.state.invoiceList.filter((x) => x.approved == true).map(r => r.id),
                                      hideSelectColumn: false
                                    }}
                                   pagination={paginationFactory(options)}

                                />
                                   {(this.state.footershow &&
        <div className="TabFooter-Pay"
        style={{ minWidth: "83.7%", width: "992px", maxWidth: "100%" }}
        >
          <div className="bulkSelectFooter">
            <span className="shift-selected-count">{this.state.selectedRows.length}
              {" "}Selected</span>
            <div className="FooterHorLine"></div>
            <span className="shift-selected-count">Invoice Total: {Utils.currencyFormatWithOutdoller(this.state.invoiceTotal)}</span>
           {hasApprovePermission && 
            <div className="action-group d-flex flex-row mr-auto">
              <Button type="button"
              //className="btn-outline-primary btnHeight"
              //  onClick={(e) => { this.handleBtnEvent(e, "", 'bulk') }}
               onClick={(x) => this.approveInvoices()}
              >Approve Invoice</Button>
            </div>
            }
          </div>
        </div>)}
                              </div>
                            </div>
                          </section>
                        </div>

                      )
                    }
                  </ToolkitProvider>


                </Tab.Pane>
               

              </Tab.Content>
            </Tab.Container>

            {(showSlideout &&
                <Customerorderslideout
                  closeSlideOut={this.closeSlideOut}
                  orderid={this.state.orderid}
                >


                </Customerorderslideout>
              )}

              {(showReceivableslideout &&
                <InvoiceEntryslideout
                  closeSlideOut={this.closeInvoiceSlideOut}
                  orderIds={this.state.orderIds}
                  invoiceId={this.state.invoiceId}
                  itemIds={this.state.itemsIds}
                >


                </InvoiceEntryslideout>
              )}
 
             {this.state.showVendorSlideout &&
             <Vendororderslideout
             closeSlideOut={this.closeVendorSlideOut}
             vendororderid={this.state.vendororderid}
             vendorordertype={this.state.vendorordertype}
             id={this.state.vendororderid}
             ></Vendororderslideout>
             }

             {this.state.showInvoice &&
              <InvoiceSlideout transactionID={this.state.transactionId} inboxId={0} showAttachment={false} emailString={""} closeSlideOut={this.closeInvoiceslideout} InvoiceType={"Vendor"}/>}
             

          </Container>



        </React.Fragment>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  permissions: state.PagePermissionReducer.permissions,
  locationId: state.LocationReducer.locationId   
});


export default connect(mapStateToProps)(InvoiceList);